<div class="w-full mb-12">
  <div class="home-banner bg-neutral-800 w-full">
    <span class="heading text-default-50 heading-l nunito-regular-font">
      Manual Review Process
    </span>
    <div class="flex justify-center banner-card-container">
      <div class="kds-Card banner-card lh-24 p-16 nunito-regular-font">
        <span class="heading-l hi-user">Hi {{ userName }},</span>
        <div
          class="flex flex-row items-center body-l ml-24"
          style="margin-top: 10.4px"
        >
          <img
            src="../../../assets/images/Paul-grocery-bag.svg"
            alt="Paul grocery bag"
          />
          <span class="ml-24 -mt-8 roboto-regular-font">
            Kroger needs help identifying the right tax code for new items and
            family tree branches.<br />To identify and resolve these items,
            click
            <span class="roboto-regular-font font-700">Get Started</span> below:
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="overlay-card-container sm:-mt-64 flex justify-center w-full">
    <div class="flex flex-col row-card-gap mx-24">
      <div class="flex flex-wrap justify-center col-card-gap">
        <app-review-card
          type="branch"
          discriptionOne="Manage tax codes for newly added"
          discriptionTwo="PIM Family Tree Branches."
          buttonText="Get Started"
          link="../branch-review"
        >
        </app-review-card>
        <app-review-card
          type="item"
          discriptionOne="Review pending items added to existing"
          discriptionTwo="branches or explore all new items by GTINs."
          buttonText="Get Started"
          link="../item-review"
        >
        </app-review-card>
        <app-review-card
          type="Facility"
          discriptionOne="Resolve incorrect or flagged addresses"
          discriptionTwo="for Kroger’s new stores."
          [disable]="true"
          buttonText="Get Started"
        >
        </app-review-card>
      </div>
      <!-- <div
        class="flex flex-col flex-wrap justify-center items-center col-card-gap"
      >
        <app-update-card
          title="Manual Review Activity"
          description="See all revisions"
          type="auditHistory"
          [disable]="true"
        ></app-update-card>
        <app-update-card
          title="Tax Category Codes"
          description="View all updated TCC"
          type="TCC"
          [disable]="true"
        ></app-update-card>
      </div> -->
    </div>
  </div>
</div>
